import { h, Component } from 'preact';
import MenuObject from '../canvas/menu-object';
import * as actions from '../actions';
import store from '../store';
import util from '../util';
import { unescapeHtml } from '../canvas/menu-object';
import { syncInGroup } from "../canvas/menu-group";
import Quill from 'quill';
import { BoldOutlined, ItalicOutlined, MoreOutlined, UnderlineOutlined } from '@ant-design/icons';

export default class MenuObjectEditNameNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      curName: '',
      curNotes: '',
      isEditMode: true,
      showGroupNotesToolbar: false
    };
  }

  updateName(name) {
    this.setState({ curName: name });
    MenuObject.updateMOName(this.props.$element, name);
    MenuObject.fixLineHeights(this.props.$element, true);
    syncInGroup(this.props.$element, store.getState().menuGroups);
  }

  updateNotes(notes) {
    this.setState({ curNotes: notes });
    MenuObject.updateMONotes(this.props.$element, notes);
    MenuObject.fixLineHeights(this.props.$element, true);
  }

  componentDidMount() {
    let foundName = this.props.$element.find('.wrapper .mo-name')?.html();
    if (foundName) {
      foundName = unescapeHtml(foundName);
      foundName = foundName.trim();
      this.setState({ curName: foundName });
    }

    let foundNotes = this.props.$element.find('.wrapper .mo-notes')?.html();
    if (foundNotes) {
      foundNotes = unescapeHtml(foundNotes);
      foundNotes = foundNotes.trim();
      this.setState({ curNotes: foundNotes });
    }

    util.nextTick(() => {
      this.initializeTextEditors(window.localStorage.getItem("mo-mode") === "notes");
      if (window.localStorage.getItem("mo-mode") !== "notes") {
        this.nameInput.focus();
      }
      window.localStorage.removeItem("mo-mode");
    }, 100);
  }

  componentWillUnmount() {
    if (this.state.curName === '') {
      this.deleteName();
    }
    if (this.state.curNotes === '') {
      this.deleteNotes();
    }
    if (this.props.$element) MenuObject.fixLineHeights(this.props.$element, true);
  }

  initializeTextEditors(focus) {
    $('#groupNotesEditor').html(this.state.curNotes);
    const descEditable = new Quill('#groupNotesEditor', {
      modules: {
        toolbar: '#groupNotesToolbar',
        keyboard: {
          bindings: {
            tab: { key: 9, handler: function () { return true; } },
            list: {
              key: 'backspace', context: { format: ['list'] },
              handler: function (range, context) {
                if (range.length === 0 && range.index !== 0) {
                  this.quill.deleteText(range.index - 1, 1, Quill.sources.USER);
                } else {
                  this.quill.deleteText(range, Quill.sources.USER);
                }
              }
            }
          }
        }
      },
      formats: ['bold', 'italic', 'underline'],
    });
    descEditable.on('text-change', this.onTextChange.bind(descEditable, this, 'group-notes'));
    $(descEditable.container).find('.ql-editor').on('paste cut', (e) => {
      this.onPasteCut(e, 'group-notes');
    })
    $(descEditable.getModule("toolbar").container).on('mousedown', (e) => {
      e.preventDefault();
    });
    const $descQlEditor = $('#groupNotesEditor .ql-editor');
    $descQlEditor.attr('tabindex', '3');
    $descQlEditor.on('focus', () => {
      $('#groupNotesEditor').addClass('focused');
      this.onNotesFocus()
    });
    $descQlEditor.on('blur', () => {
      $('#groupNotesEditor').removeClass('focused');
      this.setState({ showGroupNotesToolbar: false })
    });
    if (focus) {
      $descQlEditor.trigger('focus');
      descEditable.setSelection(descEditable.getLength(), 0);
    }
  }

  translateHTMLForCanvas(html) {
    return html.replaceAll('</p><p', '<br></p><p').replaceAll('<br><br></p><p', '<br></p><p');
  }

  onTextChange(this1, field) {
    this1.updateTextOnCanvas($(this.container).find('.ql-editor')[0], field);
  }

  onPasteCut(e, field) {
    this.updateTextOnCanvas($(e.currentTarget)[0], field);
  }

  updateTextOnCanvas(qlElement, field) {
    let toSetHTML = '';
    const blankValues = ['', '\n'];
    let innerText = qlElement.innerText;
    if (!blankValues.includes(innerText)) {
      toSetHTML = this.translateHTMLForCanvas(qlElement.innerHTML);
    }
    this.updateNotes(toSetHTML);
  }

  toggleGroupNotesToolbar(ev) {
    ev.stopPropagation();
    if (!this.state.showGroupNotesToolbar) {
      $('#groupNotesEditor .ql-editor').trigger('focus');
    }
    this.setState({ showGroupNotesToolbar: !this.state.showGroupNotesToolbar });
  }

  onNameFocus() {
    const $element = this.props.$element;
    if (!$element) return;

    const $name = $element.find('.mo-name');
    const $notes = $element.find('.mo-notes');
    if ($name) {
      $name.addClass('selected');
    }
    if ($notes) {
      $notes.removeClass('selected');
    }
  }

  onNotesFocus() {
    const $element = this.props.$element;
    if (!$element) return;

    const $name = $element.find('.mo-name');
    const $notes = $element.find('.mo-notes');
    if ($name) {
      $name.removeClass('selected');
    }
    if ($notes) {
      $notes.addClass('selected');
    }
  }

  deleteName() {
    this.props.$element.find('.wrapper .mo-name').remove();
    MenuObject.fixLineHeights(this.props.$element, true);
  }

  deleteNotes() {
    this.props.$element.find('.wrapper .mo-notes').remove();
    MenuObject.fixLineHeights(this.props.$element, true);
  }

  render(props, state) {
    if (store.getState().isMobileVersion && props.activeIdx !== state.activeIdx) {
      this.setState({ active: props.active, activeIcons: props.active.icons, activeIdx: props.activeIdx })
    }

    return (
      <div className="no-drag modal-content">
        <div className="modal-content-edit">
          <div className="item-details scroller">
            <div>

              <textarea tabIndex={1}
                ref={(input) => { this.nameInput = input; }}
                className="group-name"
                placeholder="Group name"
                spellcheck="true"
                autocomplete="off"
                value={state.curName}
                onFocus={() => this.onNameFocus()}
                onChange={e => {
                  this.updateName(e.target.value);
                }}
              />

              <div className={'group-notes'}
                id='groupNotesEditor'
              >
              </div>
              <div className={`toggle-groupnotes-toolbar ${state.showGroupNotesToolbar ? 'active' : ''}`} onMouseDown={(ev) => ev.preventDefault()} onClick={(ev) => this.toggleGroupNotesToolbar(ev)}>
                <MoreOutlined />
              </div>
              <div id="groupNotesToolbar" className={state.showGroupNotesToolbar ? 'show' : ''}>
                <button class="ql-bold"><BoldOutlined /></button>
                <button class="ql-italic"><ItalicOutlined /></button>
                <button class="ql-underline"><UnderlineOutlined /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
